export const groupEntities = <T = Record<string, unknown>>(entities: T[], key: keyof T): Record<string, T[]> => {
  return entities.reduce<Record<string, T[]>>((acc, entity) => {
    const group = String(entity[key] || 'other')
    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push(entity)
    return acc
  }, {})
}
